import DeleteCaseButton from './DeleteCaseButton';

export default DeleteCaseButton;
